import type { ReactElement } from 'react';
import { post } from 'utils/network';
import { ApiRoute, FeatureFlag, Route } from 'config';

import Plan from 'models/Plan';
import useCurrentUser from 'hooks/useCurrentUser';
import SelectPlanModal from './SelectPlanModal';

type Props = {
  show: boolean;
  standalone?: boolean;
  discount?: number;
  plan: Plan;
  setPlan: (plan: Plan) => void;
  onClose: () => void;
  discountCouponType?: 'dollar_off' | 'percentage_off';
  discountCouponValue?: number;
  loggedIn?: boolean;
  renderFollowUps?: boolean;
};

type gonData = {
  featureFlags?: Record<string, boolean>,
};

function SelectPlanModalContainer({
  show,
  standalone = false,
  discount = 0,
  plan,
  setPlan,
  onClose,
  discountCouponType,
  discountCouponValue,
  loggedIn = false,
  renderFollowUps = false,
}: Props): ReactElement {
  let areProgramsEnabled: boolean;
  let handlePlanChange;
  const { isProgramsEnabled } = (window.gon as gonData).featureFlags
  ?? { isProgramsEnabled: false };

  if (loggedIn) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { reload: reloadUser, currentUser } = useCurrentUser();
    handlePlanChange = async (newPlan?: Plan) => {
      await post(`${ApiRoute.USERS}/me/subscription`, {
        subscription: {
          plan: newPlan ? newPlan.name : plan.name,
          extra_meals: newPlan ? newPlan.selectedExtras : plan.selectedExtras,
        },
      });

      reloadUser();
    };

    areProgramsEnabled = currentUser
      .hasFeatureEnabled(FeatureFlag.PROGRAMS);
  } else {
    areProgramsEnabled = isProgramsEnabled;
    handlePlanChange = async (newPlan?: Plan) => {
      window.location.href = `${Route.SIGNUP_CREATE_ACCOUNT}?plan=${newPlan ? newPlan.name : plan.name}`;
    };
  }

  return (
    <>
      <SelectPlanModal
        show={show}
        standalone={standalone}
        discount={discount}
        plan={plan}
        setPlan={setPlan}
        onClose={onClose}
        discountCouponType={discountCouponType}
        discountCouponValue={discountCouponValue}
        areProgramsEnabled={areProgramsEnabled}
        handlePlanChange={handlePlanChange}
        renderFollowUps={renderFollowUps}
      />
    </>
  );
}

export default SelectPlanModalContainer;
